import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Utility function to trim string values while preserving non-string values
 * @param {any} value - The value to potentially trim
 * @returns {any} - Trimmed string if value is string, otherwise returns original value
 */
export const trimIfString = (value) => {
  if (typeof value === 'string') {
    return value.trim();
  }
  return value;
};

/**
 * Recursively trims all string values in an object
 * @param {object} obj - The object to process
 * @returns {object} - Object with trimmed string values
 */
export const trimObjectStrings = (obj) => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => trimObjectStrings(item));
  }

  if (typeof obj === 'object') {
    const trimmedObj = {};
    for (const [key, value] of Object.entries(obj)) {
      trimmedObj[key] = trimObjectStrings(value);
    }
    return trimmedObj;
  }

  return trimIfString(obj);
};

export const removeHtmlTags = (string) => {
  if (typeof string !== 'string') {
    return '';
  }
  let tmp = document.createElement('div');
  tmp.innerHTML = string;
  return tmp.textContent || tmp.innerText || '';
};

export const formatUkDateFromString = (value, returnTime = false) => {
  if (!value) {
    return '';
  }

  const dateObj = new Date(value);
  const ukDate = dateObj.toLocaleDateString('en-UK');
  const ukTime = dateObj.toLocaleTimeString('en-UK', { hour: '2-digit', minute: '2-digit' });

  const returnValue = ukDate + (returnTime ? ' at ' + ukTime : '');

  return ukDate === 'Invalid Date' ? value : returnValue;
};

export const parseClearanceDate = (dateString) => {
  const date = dayjs.utc(dateString);
  return {
    date: date.format('YYYY-MM-DD'),
    time: date.format('HH:mm'),
  };
};

//#region Report data preprocessing CABS-2787
export const parseDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value !== 'string') return null;

  const parts = value.trim().split(' ');
  const datePart = parts[0];
  let timePart = parts.slice(1).join(' ') || '00:00:00';

  // support dd/mm/yyyy
  if (datePart.includes('/')) {
    const [day, month, year] = datePart.split('/');
    if (!day || !month || !year) return null;
    const timeSegments = timePart.split(':');
    if (timeSegments.length === 1) timePart = '00:00:00';
    if (timeSegments.length === 2) timePart = `${timePart}:00`;
    const iso = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timePart}`;
    const dt = new Date(iso);
    return isNaN(dt) ? null : dt;
  }

  // try ISO-like input (yyyy-mm-dd ...)
  const iso = `${datePart}T${timePart}`;
  const dt = new Date(iso);
  return isNaN(dt) ? null : dt;
};

//#endregion
